import Vue from 'vue'
import VueRouter from 'vue-router'
import {decode} from "jsonwebtoken";

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue'),
      meta: {
        pageTitle: 'Home',
        authRequired: true,
        breadcrumb: [
          {
            text: 'Home',
            active: true,
          },
        ],
      },
    },
    {
      path: '/bank-slips',
      name: 'bank-slips',
      component: () => import('@/views/BankSlips.vue'),
      meta: {
        pageTitle: 'Meus Boletos',
        authRequired: true,
        breadcrumb: [
          {
            text: 'Meus Boletos',
            active: true,
          },
        ],
      },
    },
    {
      path: '/contract-resume',
      name: 'contract-resume',
      component: () => import('@/views/ContractResume.vue'),
      meta: {
        pageTitle: 'Meu Contrato',
        authRequired: true,
        breadcrumb: [
          {
            text: 'Meu contrato',
            active: true,
          },
        ],
      },
    },
    {
      path: '/income-tax',
      name: 'income-tax',
      component: () => import('@/views/IncomeTax.vue'),
      meta: {
        pageTitle: 'Imposto de renda',
        authRequired: true,
        breadcrumb: [
          {
            text: 'Imposto de renda',
            active: true,
          },
        ],
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        authRequired: false,
        layout: 'full',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        authRequired: false,
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('RgSaude@Token')

  if (to.meta.authRequired) {
    if (token !== null) {
      const { exp: expiration } = decode(token)
      const isExpired = !!expiration && Date.now() > expiration * 1000

      window.document.title = `RG Saúde | ${to.meta.pageTitle}`

      if (isExpired) {
        localStorage.removeItem('RgSaude@Token')
        next({ name: 'login' })
      } else {
        next()
      }
    } else {
      localStorage.removeItem('RgSaude@Token')
      next({ name: 'login' })
    }
  } else {
    next()
  }
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
